module.exports = __webpack_public_path__ + "img/4-penguin-helper_v8e_loading.5b5d4484.jpg";